var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#21A6E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8388 25V17.7027H21.499L21.8964 14.8559H18.8388V13.036C18.8388 12.5796 18.9367 12.2432 19.1324 12.027C19.3628 11.7748 19.7774 11.6486 20.3762 11.6486H22V9.10811C21.8157 9.08408 21.5278 9.06006 21.1363 9.03604C20.6296 9.01201 20.1228 9 19.6161 9C18.833 9 18.142 9.14414 17.5432 9.43243C16.9443 9.72072 16.4808 10.1471 16.1526 10.7117C15.8244 11.2763 15.6603 11.955 15.6603 12.7477V14.8559H13V17.7027H15.6603V25H18.8388Z",
    fill: "#F8FAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/Fb.a90d67fc9a6abb86da382617c7a65abf.svg";
export { ForwardRef as ReactComponent };